export const checkboxLabel = 'Test Checkbox Label';

export const CheckboxInputDefProps = {
  checked: false,
  checkboxLabel: checkboxLabel,
  onClick: () => {}
};